import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {useServices} from "../../../hooks/use-services.hook";
import {ArrowDownIcon} from "../../../assets/svg/arrow-down.icon";

const HeaderBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${props => props.theme.spacing.flexGap12};
    width: 100%;
    justify-content: flex-start;
    color: ${props => props.theme.colors.mediumTint};
`

const TitleBox = styled.div`
    color: ${props => props.theme.colors.darkTint};
    font-size: ${props => props.theme.fontSize.h3};
    font-weight: ${props => props.theme.fontWeight.semiBold};
    line-height: 1;
`

export const SearchMaskTitleComponent: React.FC<{className?: string}> = observer((props) => {
    const services = useServices();
    return (
        <HeaderBox className={props.className}>
            <TitleBox>
                {services.language.translate('Your next flight awaits')}
            </TitleBox>
            <ArrowDownIcon/>
        </HeaderBox>
    )
})